var t="data-testid",r=function(r){var a;return(a={})[t]=r,a};export{t as TEST_ID_ATTRIBUTE_NAME,r as getTestAttrs};
